import {Observable} from 'rxjs';
const {throw: throwError, timer} = Observable;
import {mergeMap, finalize} from 'rxjs/operators';

export default ({
	maxRetryAttempts = 3,
	scalingDuration = 1000,
	excludedStatusCodes = [],
	// eslint-disable-next-line
	failureAction = error => console.error(error),
}) => attempts =>
	attempts.pipe(
		mergeMap((error, i) => {
			const retryAttempt = i + 1;
			if (
				retryAttempt > maxRetryAttempts ||
				excludedStatusCodes.find(e => e === error.status)
			) {
				return throwError(error);
            }

			return timer(retryAttempt * scalingDuration);
		}),
		finalize(failureAction)
	);



// WEBPACK FOOTER //
// ./src/epics/retryStrategy.js